<pr-status-label
  class="w-16"
  [dense]="true"
  [label]="status$ | async"
  [color]="colour$ | async"
  [matTooltip]="errorMessage"
  [matTooltipDisabled]="!errorMessage"
/>
